module.exports = __webpack_public_path__ + "static/venice-1035684_1920@2x-02479bdcdc007c51d627c5ef5891a384.png";